import React, { ReactElement } from 'react';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';

const MapSearchBox = ({ onSearchBoxMounted, inputText, onPlacesChanged, setSearchBoxText }: any): ReactElement => {
  return (
    <SearchBox
      ref={onSearchBoxMounted}
      controlPosition={google.maps.ControlPosition.TOP_LEFT}
      onPlacesChanged={onPlacesChanged}
    >
      <input type="text" value={inputText}
        onChange={(e: any): void => setSearchBoxText(e.target.value)}
        className="g-map-search-box" placeholder="Search place here" />
    </SearchBox>
  );
};

export default MapSearchBox;
